import styled from 'styled-components';

export const DeclineAndClose = styled('button')`
  border: 0;
  outline: 0;
  text-decoration: underline;
  background-color: white;
  margin-bottom: 34px;
  /* Bootstrap 5 removed justify-content: space-between from .modal-header.
     Custom close buttons no longer auto-align right — need explicit margin-left: auto. */
  margin-left: auto;
`;

export const SwitchContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 436px;
  margin: 6px 0px 18px;
`;

export const SwitchLabel = styled('span')`
  font-size: 14px;
  line-height: 17px;
`;
